var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIron(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 481.39 457.83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-3 {\r\n        fill: url(#linear-gradient3);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient3",
    y1: 228.92,
    x2: 481.39,
    y2: 228.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#7d7d7d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#7e7e7e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#060606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#717171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#555554"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#171717"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "240.7 0 315.08 150.71 481.39 174.88 361.05 292.19 389.45 457.83 240.7 379.63 91.94 457.83 120.35 292.19 0 174.88 166.32 150.71 240.7 0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIron);
export default __webpack_public_path__ + "static/media/iron.6ceb96e824d05be4dfbbb06cf0f3ccec.svg";
export { ForwardRef as ReactComponent };